module.exports = __webpack_public_path__ + "img/fangan3.30115f8a.png";